






























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import Availability from '@/models/Workers/Availability';
import WorkerDto from '@/models/Workers/IWorkerAvailability';
import IWorkerAvailability from '@/models/Workers/IWorkerAvailability';

@Component({
  name: 'WorkerAvailability',
  components: {  }
})
export default class extends Vue {

    @Prop()
    worker: IWorkerAvailability;
	
	get IsAvailableMonAM() {
		return this.worker.availability.includes(Availability.MonAM)
	}
	
	get IsAvailableTueAM() {
		return this.worker.availability.includes(Availability.TueAM)
	}
	
	get IsAvailableWedAM() {
		return this.worker.availability.includes(Availability.WedAM)
	}
	
	get IsAvailableThuAM() {
		return this.worker.availability.includes(Availability.ThuAM)
	}
	
	get IsAvailableFriAM() {
		return this.worker.availability.includes(Availability.FriAM)
	}

	get IsAvailableSatAM() {
		return this.worker.availability.includes(Availability.SatAM)
	}

	get IsAvailableSunAM() {
		return this.worker.availability.includes(Availability.SunAM)
	}
	
	get IsAvailableMonPM() {
		return this.worker.availability.includes(Availability.MonPM)
	}
	
	get IsAvailableTuePM() {
		return this.worker.availability.includes(Availability.TuePM)
	}
	
	get IsAvailableWedPM() {
		return this.worker.availability.includes(Availability.WedPM)
	}
	
	get IsAvailableThuPM() {
		return this.worker.availability.includes(Availability.ThuPM)
	}
	
	get IsAvailableFriPM() {
		return this.worker.availability.includes(Availability.FriPM)
	}
	
	get IsAvailableSatPM() {
		return this.worker.availability.includes(Availability.SatPM)
	}
	
	get IsAvailableSunPM() {
		return this.worker.availability.includes(Availability.SunPM)
	}

	availabilityClass(isAvailable: boolean){
		if (isAvailable) {
			return "available";
		} 
		else {
			return "unavailable";
		}
	}
}
